<!-- <mat-drawer-container class="sidenav-container">
  <mat-drawer
    #drawer
    class="sidenav"
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="!(isHandset$ | async)"
    [ngClass]="{
      sideNavExpanded: isExpanded,
      sideNavCollapsed: !isExpanded,
      sideNavTouch: isHandset$ | async
    }"
  >
    <mat-toolbar
      color="primary"
      fxLayoutAlign="end center"
      *ngIf="isHandset$ | async"
    >
      <button
        mat-icon-button
        (click)="drawer.toggle(); isExpanded = true"
        onclick="this.blur()"
        autofocus="false"
      >
        <mat-icon>menu</mat-icon>
      </button>
    </mat-toolbar>
  </mat-drawer>

  <mat-drawer-content
    [ngClass]="{
      sidenavContentExpanded: isExpanded,
      sidenavContentCollapsed: (isHandset$ | async) || !isExpanded,
      sidenavContentMobile: (isHandset$ | async)
    }"
  >
    <mat-toolbar color="primary" fxLayout="column">
      <mat-toolbar-row
        fxLayout="row"
        fxLayoutAlign="space-between center"
        style="display: flex; justify-content: space-between"
      >
        <div *ngIf="!(isHandset$ | async)">
          <button
            mat-icon-button
            (click)="isExpanded = !isExpanded; drawer.open()"
            onclick="this.blur()"
          >
            <mat-icon>menu</mat-icon>
          </button>
        </div>
        <div *ngIf="isHandset$ | async">
          <button
            mat-icon-button
            class="seneca-header-menu mat-icon-button"
            (click)="drawer.toggle(); isExpanded = true"
            onclick="this.blur()"
          >
            <mat-icon>menu</mat-icon>
          </button>
        </div>

        <div
          fxLayoutAlign="center center"
          fxLayout="row"
          fxFlex.lt-md="1 1 auto"
          class="title"
        >
          <img
            (click)="onHomeClick()"
            class="seneca-logo"
            fxFlexAlign.lt-sm="center"
            fxFlex.lt-sm="1 1 auto"
            src="assets/img/logo_white.svg"
          />
          <p class="header__text" fxHide.lt-lg>
            International Online Application
          </p>
        </div>
        <mat-nav-list
          fxLayout="row"
          fxFlex="1 1 auto"
          fxLayoutAlign="end center"
          fxHide.lt-md
          [ngClass]="{
            sidenavContentExpanded: isExpanded,
            sidenavContentCollapsed: (isHandset$ | async) || !isExpanded,
            sidenavContentMobile: (isHandset$ | async)
          }"
        >
          <button mat-button (click)="onHomeClick()">
            <div class="nav-item">
              <mat-icon class="icon">home</mat-icon>
              <span>Home</span>
            </div>
          </button>
          <button mat-button>
            <div class="nav-item">
              <img
                ngxGravatar
                [email]="user.emails[0]"
                fallback="mm"
                size="24"
              />
              <span>{{ user.name }}</span>
            </div>
          </button>
          <button mat-button (click)="onSignOutClick()">
            <div class="nav-item">
              <mat-icon class="icon">exit_to_app</mat-icon>
              <span> Sign out</span>
            </div>
          </button>
        </mat-nav-list>
      </mat-toolbar-row>
    </mat-toolbar>

    <ng-content></ng-content>
  </mat-drawer-content>
</mat-drawer-container> -->

<mat-drawer-container class="sidenav-container">
  <mat-drawer
    #drawer
    class="sidenav"
    [attr.role]="'navigation'"
    [mode]="'side'"
    [opened]="!(isHandset$ | async)"
    [ngClass]="{
      sideNavExpanded: isExpanded,
      sideNavCollapsed: !isExpanded,
      sideNavTouch: isHandset$ | async
    }"
    *ngIf="isHandset$ | async"
    id="top-sidenav"
  >
    <mat-nav-list *ngIf="isHandset$ | async" class="nav-mobile">
      <button mat-button (click)="onHomeClick()">
        <div class="nav-item">
          <mat-icon class="icon">home</mat-icon>
          <span style="font-size: 1.2em">Home</span>
        </div>
      </button>
      <button mat-button>
        <div class="nav-item">
          <img ngxGravatar [email]="user.emails[0]" fallback="mm" size="24" />
          <span style="font-size: 1.2em">{{ user.name }}</span>
        </div>
      </button>
      <button mat-button (click)="onSignOutClick()">
        <div class="nav-item">
          <mat-icon class="icon">exit_to_app</mat-icon>
          <span style="font-size: 1.2em"> Sign out</span>
        </div>
      </button>

      <!-- Add other nav items here as a single menu option if needed -->
    </mat-nav-list>
  </mat-drawer>

  <mat-drawer-content [ngClass]="{ sidenavContentMobile: isHandset$ | async }">
    <mat-toolbar color="primary">
      <mat-toolbar-row
        fxLayout="row"
        fxLayoutAlign="space-between center"
        style="display: flex; justify-content: space-between"
      >
        <button
          mat-icon-button
          (click)="drawer.toggle(); isExpanded = true"
          onclick="this.blur()"
          autofocus="false"
          *ngIf="isHandset$ | async"
        >
          <mat-icon>menu</mat-icon>
        </button>
        <div
          fxLayoutAlign="center center"
          fxLayout="row"
          fxFlex.lt-md="1 1 auto"
          class="title"
        >
          <img
            (click)="onHomeClick()"
            class="seneca-logo"
            fxFlexAlign.lt-sm="center"
            fxFlex.lt-sm="1 1 auto"
            src="assets/img/logo_white.svg"
          />
          <p class="header__text" fxHide.lt-lg>
            International Online Application
          </p>
        </div>

        <!-- Desktop-only nav items -->

        <mat-nav-list
          fxLayout="row"
          fxFlex="1 1 auto"
          fxLayoutAlign="end center"
          fxHide.lt-md
          [ngClass]="{
            sidenavContentExpanded: isExpanded,
            sidenavContentCollapsed: (isHandset$ | async) || !isExpanded,
            sidenavContentMobile: (isHandset$ | async)
          }"
          *ngIf="!(isHandset$ | async)"
        >
          <button mat-button (click)="onHomeClick()">
            <div class="nav-item">
              <mat-icon class="icon">home</mat-icon>
              <span>Home</span>
            </div>
          </button>
          <button mat-button>
            <div class="nav-item">
              <img
                ngxGravatar
                [email]="user.emails[0]"
                fallback="mm"
                size="24"
              />
              <span>{{ user.name }}</span>
            </div>
          </button>
          <button mat-button (click)="onSignOutClick()">
            <div class="nav-item">
              <mat-icon class="icon">exit_to_app</mat-icon>
              <span> Sign out</span>
            </div>
          </button>
        </mat-nav-list>
      </mat-toolbar-row>
    </mat-toolbar>
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      fxFlex="85%"
      fxFlex.lt-md="95%"
      class="app-number-container"
    >
      <h2 class="sub-header__title">Welcome to Seneca Polytechnic</h2>
      <div
        fxLayout="column"
        fxLayoutAlign="center end"
        fxLayoutGap=".5em"
        fxFlexAlign="end"
        *ngIf="!isAtHomeScreen"
      >
        <p *ngIf="applicationId">
          <span fxHide.lt-md>Application Number: </span>{{ applicationId }}
        </p>
        <p style="text-align: end" *ngIf="applicationStatus">
          <span fxHide.lt-md>Status: </span>{{ applicationStatus }}
        </p>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="center" class="sub-header__container">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        fxFlex="85%"
        fxFlex.lt-md="95%"
      ></div>
    </div>
    <ng-content></ng-content>
    <ng-content></ng-content>
  </mat-drawer-content>
</mat-drawer-container>
